import {ILinkEnvironment} from "./environment.interface";
import {Brands} from "@server-models";

export const environment: ILinkEnvironment = {
  production: true,
  brand: Brands.Semco,
  apiUrl: {
    one: 'https://api-dev.one.on-n1.com',
    pageDefaultSize: 50,
    defaultTimeoutSec: 30,
    tokenExpireOffsetSec: 120
  },
  lang: {
    defaultLanguage: "en-US",
    isUseBrowserLanguage: false
  },
};
